import { NgModule } from "@angular/core";
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { LabelModule } from "@progress/kendo-angular-label";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ExcelModule , GridModule } from '@progress/kendo-angular-grid';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { IconsModule, IconModule } from "@progress/kendo-angular-icons";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { ListViewModule } from "@progress/kendo-angular-listview";
import { PagerModule } from "@progress/kendo-angular-pager";
import { DialogsModule } from '@progress/kendo-angular-dialog';
import "@progress/kendo-angular-intl/locales/fr/all";
import { CommonModule } from "@angular/common";


@NgModule({
    imports:[
    CommonModule,
    DropDownsModule,
    LabelModule,
    GridModule,
    ExcelModule ,
    ProgressBarModule ,
    IconsModule,
    IconModule,
    LayoutModule,
    ListViewModule,
    PagerModule,
    DialogsModule,
    WindowModule,
    DateInputsModule,
    InputsModule,
    TreeViewModule
   ],
  exports:[
    DropDownsModule,
    LabelModule,
    GridModule,
    ExcelModule ,
    ProgressBarModule ,
    IconsModule,
    IconModule,
    LayoutModule,
    ListViewModule,
    PagerModule,
    DialogsModule,
    WindowModule,
    DateInputsModule,
    InputsModule,
    TreeViewModule
   ]
})
export class KendoAllModule{}

